// extracted by mini-css-extract-plugin
export default {"login":"Login_login__jJiFM","loginForm":"Login_loginForm__1kk93"};